import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

export default React.memo(props => (
  <SvgIcon {...props} width="16" height="16" viewBox="0 0 16 16" fill="none">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.50002 3.66666C4.03978 3.66666 3.66669 4.03975 3.66669 4.49999V10.1667C3.66669 10.6269 4.03978 11 4.50002 11H4.83335C5.1095 11 5.33335 11.2238 5.33335 11.5C5.33335 11.7761 5.1095 12 4.83335 12H4.50002C3.4875 12 2.66669 11.1792 2.66669 10.1667V4.49999C2.66669 3.48747 3.4875 2.66666 4.50002 2.66666H11.5C12.5126 2.66666 13.3334 3.48747 13.3334 4.49999V6.16666C13.3334 6.4428 13.1095 6.66666 12.8334 6.66666C12.5572 6.66666 12.3334 6.4428 12.3334 6.16666V4.49999C12.3334 4.03975 11.9603 3.66666 11.5 3.66666H4.50002Z"
      fill="currentColor"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M7.83335 8.99999C7.7413 8.99999 7.66669 9.0746 7.66669 9.16666V12.1667C7.66669 12.2587 7.7413 12.3333 7.83335 12.3333H12.1667C12.2587 12.3333 12.3334 12.2587 12.3334 12.1667V9.16666C12.3334 9.0746 12.2587 8.99999 12.1667 8.99999H7.83335ZM6.66669 9.16666C6.66669 8.52231 7.18901 7.99999 7.83335 7.99999H12.1667C12.811 7.99999 13.3334 8.52231 13.3334 9.16666V12.1667C13.3334 12.811 12.811 13.3333 12.1667 13.3333H7.83335C7.18901 13.3333 6.66669 12.811 6.66669 12.1667V9.16666Z"
      fill="currentColor"
    />
  </SvgIcon>
));
